import { Link } from "react-router-dom";
import { ArrowUpRight, Briefcase, ShoppingBag, TrendingUp, GitMerge, Calculator, Users, Handshake } from "lucide-react";

const SERVICES = [
  { icon: ShoppingBag, title: "Sell Your Business", desc: "Reach qualified buyers across MENA and Africa.", to: "/dashboard" },
  { icon: Briefcase, title: "Buy A Business", desc: "Discover vetted opportunities and acquire at scale.", to: "/marketplace" },
  { icon: TrendingUp, title: "Raise Capital", desc: "Connect with active angel, VC and family-office capital.", to: "/dashboard" },
  { icon: GitMerge, title: "Mergers & Acquisitions", desc: "Strategic transactions — sourcing through close.", to: "/contact" },
  { icon: Calculator, title: "Business Valuation", desc: "AI-powered valuations in 60 seconds.", to: "/valuation" },
  { icon: Users, title: "Investor Matching", desc: "AI matches founders with the right capital.", to: "/ai-tools" },
  { icon: Handshake, title: "Strategic Partnerships", desc: "Find growth partners — JVs, channels, M&A.", to: "/contact" },
];

export default function ServicesPage() {
  return (
    <div data-testid="services-page" className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <span className="dv-eyebrow">Services</span>
      <h1 className="dv-display text-4xl md:text-6xl mt-3 mb-4 max-w-3xl leading-tight">Everything you need to buy, sell, raise, or partner.</h1>
      <p className="text-lg text-slate-600 max-w-2xl">Each service is purpose-built for entrepreneurs and investors in Africa and the Middle East.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {SERVICES.map((s, i) => (
          <Link to={s.to} key={i} className="bg-white border border-slate-200 rounded-2xl p-7 group hover:border-blue-500 hover:-translate-y-1 transition-all" data-testid={`service-${i}`}>
            <div className="flex items-start justify-between mb-5">
              <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center"><s.icon size={22} className="text-blue-600" /></div>
              <ArrowUpRight size={18} className="text-slate-300 group-hover:text-blue-600" />
            </div>
            <h3 className="font-bold text-xl mb-2 text-slate-900">{s.title}</h3>
            <p className="text-slate-600 text-[15px] leading-relaxed">{s.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
